import Parse from 'parse';
import { singleEntityLoading } from '../mixins/loading-states';
/**
 * @class NewsModule
 */
const NewsModule = {
  namespaced: true,
  state: {
    ...singleEntityLoading.state,
    news: null,
  },
  mutations: {
    ...singleEntityLoading.mutations,
    setNews(state, news) {
      state.news = news;
    },
  },
  actions: {
    ...singleEntityLoading.actions,
    loadNews({ state, commit, rootState }) {
      commit('setLoading');
      window.axios.get(`https://www.viacor.de/appexport/news.php?lang=${rootState.user.language}`).then((result) => {
        commit('setLoaded');
        let news = result.data;
        news.length = 10;
        commit('setNews', news);
      });
    },
  },
  getters: {
    ...singleEntityLoading.getters,
    news: (state) => state.news || [],
  },
};

export default NewsModule;
